import { topicIndex } from '@/mocks/homeData';

const colorMap: Record<string, string> = {
  accent: 'bg-accent-100 text-accent-700',
  primary: 'bg-primary-100 text-primary-700',
  secondary: 'bg-secondary-100 text-secondary-700',
};

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-100/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            吃瓜专题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            八大主题频道，总有一款瓜适合你
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {topicIndex.map((item, idx) => (
            <a
              key={idx}
              href="#ranking"
              className="group flex flex-col items-center p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-300/60 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-50 group-hover:bg-accent-100 transition-colors duration-300 mb-3">
                <i className={`${item.icon} text-accent-500 text-xl`}></i>
              </div>
              <h3 className="text-sm font-heading font-semibold text-foreground-900 mb-1 whitespace-nowrap">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 text-center mb-2 line-clamp-1">
                {item.desc}
              </p>
              <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${colorMap[item.color]}`}>
                {item.count}条
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}